import type { Pinia } from 'pinia'
import { useDictionaryStore } from '@/store/modules/dictionary'

/**
 * 注册后台字典启动器。
 *
 * 触发规则：
 * - 已登录
 * - 动态路由已生成
 *
 * 字典初始化失败时只记录错误，不把 watcher 打挂。
 */
export function setupDictionaryBootstrap(pinia: Pinia) {
  const appAccountStore = useAppAccountStore(pinia)
  const appRouteStore = useAppRouteStore(pinia)
  const dictionaryStore = useDictionaryStore(pinia)

  watch(
    [
      () => appAccountStore.isLogin,
      () => appRouteStore.isGenerate,
      () => appAccountStore.permissions.slice().join(','),
    ],
    async ([isLogin, isGenerate]) => {
      if (isLogin === false) {
        dictionaryStore.clear()
        return
      }

      if (isGenerate === false) {
        return
      }

      try {
        await dictionaryStore.init(true)
      }
      catch (error) {
        console.error('后台字典初始化失败', error)
      }
    },
    { immediate: true },
  )
}
